import { isPlatform } from '@ionic/vue'

export type AppPlatform = 'android' | 'ios' | 'web'

export function getAppPlatform(): AppPlatform {
  if (isPlatform('android')) return 'android'
  if (isPlatform('ios')) return 'ios'
  return 'web'
}
